export default {
  Blender: {
    confidence: 90,
    info:
      "I spent the summer of 2020 ABSORBED in Blender, and learned everything I possibly could about it",
    projects: [],
  },
  "Google Suite": {
    confidence: 100,
    info:
      "I'm very familiar with Google Docs/Slides, and I frequently use Google Apps Scipt to enhance my Google Sheets experience",
    projects: [],
  },
  "Microsoft Office": {
    confidence: 70,
    info: "In my youth I used to make animations using PowerPoint",
    projects: [],
  },
  iMovie: {
    confidence: 80,
    info: "I made many ridiculous videos with my brother using iMovie",
    projects: [],
  },
  "AutoDesk Inventor": {
    confidence: 50,
    info: "I took a class in high school which required autoCAD proficiency",
    projects: [],
  },
};
